import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-footer-loader',
  templateUrl: './footer-loader.component.html',
  styleUrls: ['../footer.component.scss'],
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule],
})
export class FooterLoaderComponent {}
